import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse, createParamString } from 'data_sources/constants';

export type RoleGroupResponseItem = {
  groupId: string;
  groupName: string;
};

export type RoleGroupsResponse = {
  groups: RoleGroupResponseItem[];
};

export default function useRoleGroups(
  organizationId: string,
  roleId: string,
  params = {},
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/lexid/admin-role/v1/organizations/${organizationId}/roles/${roleId}/groups`;
  return useQuery<RoleGroupsResponse, ServerErrorResponse>(
    ['role_groups', organizationId, roleId],
    async ({ signal }): Promise<RoleGroupsResponse> => {
      try {
        if (!organizationId || !roleId) {
          return { groups: [] };
        }
        const paramString = createParamString(params);
        const data: RoleGroupsResponse = await fetcher({
          method: 'get',
          url: `${url}?${paramString}`,
          options: { signal },
        });

        return data;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      keepPreviousData: true,
      enabled: !!organizationId && !!roleId,
      ...options,
    }
  );
}
